import { render, staticRenderFns } from "./FileChooser.vue?vue&type=template&id=fca3d6d4&scoped=true&"
import script from "./FileChooser.vue?vue&type=script&lang=js&"
export * from "./FileChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca3d6d4",
  null
  
)

export default component.exports